import { Link } from 'react-router'
import PatchworkBlock from './Patchwork'

/** "Page not found" content: the * route, unknown tutorials and collections, and empty search results. */
export default function NotFound({ message = "We couldn't find the page you're looking for." }: { message?: string }) {
  return (
    <div className="qt-container flex flex-col items-center gap-5 py-24 text-center">
      <div className="grid grid-cols-2 gap-2">
        <PatchworkBlock block="hourglass" color="bg-qt-block-1" className="size-16" />
        <PatchworkBlock block="star" color="bg-qt-block-2" className="size-16" />
        <PatchworkBlock block="nine" color="bg-qt-block-3" className="size-16" />
        <PatchworkBlock block="pinwheel" color="bg-qt-block-5" className="size-16" />
      </div>
      <p className="text-xl font-extrabold">{message}</p>
      <Link to="/tutorials" className="rounded-2xl bg-qt-primary px-6 py-3.5 text-base font-bold text-white hover:bg-qt-primary-hover">
        Browse all tutorials
      </Link>
    </div>
  )
}
